/**
 * Tailles des marqueurs selon le zoom.
 *
 * Chaque barème est une liste de paliers [zoom, taille] : petit de loin pour
 * que 705 points restent lisibles sans se recouvrir, plus gros de près.
 * Triangle et carré sont légèrement plus grands que le cercle à zoom égal —
 * à surface identique, une forme anguleuse paraît plus petite.
 */

export const CIRCLE_RADIUS = [[4, 2.4], [8, 3.4], [12, 5], [15, 6.5]] // GMF
export const TRIANGLE_SIZE = [[4, 0.34], [8, 0.46], [12, 0.64], [15, 0.80]] // GMF-U
export const SQUARE_SIZE = [[4, 0.30], [8, 0.42], [12, 0.60], [15, 0.75]] // hôpital

/**
 * Grossissement d'un marqueur mis en avant — survolé ou sélectionné.
 *
 * Les deux états partagent la même taille : un marqueur sélectionné reste
 * simplement « comme survolé », ce qui le désigne sans rien ajouter par-dessus.
 * C'est ce qui remplace l'anneau noir d'autrefois, posé autour du point et
 * jugé trop lourd.
 */
export const EMPHASIS_RATIO = 1.7 * 1.2 // 2,04

/** Barème -> expression `interpolate` de MapLibre. */
export function toExpression(stops, multiplier = 1) {
  const expr = ['interpolate', ['linear'], ['zoom']]
  for (const [zoom, size] of stops) expr.push(zoom, size * multiplier)
  return expr
}

/**
 * Même interpolation, mais calculée en JS.
 *
 * L'animation de survol doit fixer une taille numérique image par image :
 * MapLibre interpole sur le zoom, pas sur le temps, et ne peut donc pas la
 * produire.
 */
export function evalAtZoom(zoom, stops) {
  if (zoom <= stops[0][0]) return stops[0][1]
  for (let i = 1; i < stops.length; i++) {
    const [z, size] = stops[i]
    if (zoom <= z) {
      const [prevZ, prevSize] = stops[i - 1]
      const t = (zoom - prevZ) / (z - prevZ)
      return prevSize + (size - prevSize) * t
    }
  }
  return stops[stops.length - 1][1]
}
